import card_1 from 'assets/images/finance/insights/new_card_1.png'
import card_3 from 'assets/images/finance/insights/new_card_3.png'
import card_2 from 'assets/images/finance/insights/new_card_no_expense.png'

import i18n from 'modules/core/lib/i18n'

import { SectionData } from '../../types'

export const sections = (): SectionData[] => {
  return [
    {
      id: 'payrollsummaries',
      title: i18n.t(
        'finance.financial_workspace.payroll.landing.expenses_sections.payrollsummaries.title'
      ),
      description: i18n.t(
        'finance.financial_workspace.payroll.landing.expenses_sections.payrollsummaries.description'
      ),
      img: card_1,
    },
    {
      id: 'expenses',
      title: i18n.t(
        'finance.financial_workspace.payroll.landing.no_expenses_sections.expenses.title'
      ),
      description: i18n.t(
        'finance.financial_workspace.payroll.landing.no_expenses_sections.expenses.description'
      ),
      img: card_2,
    },
    {
      id: 'managecosts',
      title: i18n.t(
        'finance.financial_workspace.payroll.landing.expenses_sections.managecosts.title'
      ),
      description: i18n.t(
        'finance.financial_workspace.payroll.landing.expenses_sections.managecosts.description'
      ),
      img: card_3,
    },
  ]
}
